import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { reaction } from 'mobx';
import { observable } from 'mobx';

class FooterStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable utmSource;
  @observable company = '海南西山居互动娱乐科技有限公司';

  use() {
    super.use();
    useMount(() => {
      reaction(
        () => this.utmSource,
        () => {
          if (this.utmSource === 'sem' || this.utmSource === 'pz') {
            this.company = '成都西山居世游科技有限公司';
          }
        },
        {
          fireImmediately: true
        }
      );
    });
  }
}

export default FooterStore;
